import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons';

import NewPropertyButton from 'bundles/research/index/properties/new/button';
import PageHeader from 'components/page_header';
import PropertiesActionDropdown from 'bundles/research/index/properties/properties_action_dropdown';
import ViewToggle from 'bundles/research/index/properties/view_toggle';

import { downloadPropertiesAsCsv } from 'bundles/research/index/store/actions/search';
import { getCanExportPermission } from 'bundles/research/index/store/selectors/ui';

export function PropertiesPageHeader({
  canExport,
  currentPage,
  downloadPropertiesAsCsv,
  emptyStateHelpPath,
  insights,
  newPropertyPath,
  pageSize,
  properties,
  svnMember,
  totalCount
}) {
  const pageData = {
    currentPage: currentPage,
    itemCount: properties.length,
    itemSingularLabel: 'property',
    pageSize: pageSize,
    totalCount: totalCount
  };

  return (
    <PageHeader
      iconDescription="Manage your property database"
      iconName={faBuilding}
      iconSize="lg"
      iconText="Properties"
      iconType="icon"
      pageData={pageData}
    >
      <div className="top-bar">
        <div className="d-inline-block hidden-sm hidden-xs">
          { svnMember &&
            <a
              className="mr-4 visible-lg-inline"
              href={emptyStateHelpPath}
              rel="noopener noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon icon={faQuestionCircle} />
              <span className="ml-2">How to use your Properties Database</span>
            </a>
          }
          <ViewToggle/>
          <PropertiesActionDropdown />
          {canExport && (
            <button className="btn btn-dark right-buffer-md" onClick={downloadPropertiesAsCsv}>
              Export as CSV
            </button>
          )}
        </div>
        <NewPropertyButton insights={insights} newPropertyPath={newPropertyPath} />
      </div>
    </PageHeader>
  );
}

PropertiesPageHeader.propTypes = {
  canExport: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  downloadPropertiesAsCsv: PropTypes.func.isRequired,
  emptyStateHelpPath: PropTypes.string.isRequired,
  insights: PropTypes.bool,
  newPropertyPath: PropTypes.string.isRequired,
  pageSize: PropTypes.number.isRequired,
  properties: PropTypes.array.isRequired,
  svnMember: PropTypes.bool.isRequired,
  totalCount: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  ...state.search.meta,

  canExport: getCanExportPermission(state),
  emptyStateHelpPath: state.paths.emptyStateHelp,
  insights: state.features.insights,
  newPropertyPath: state.paths.newProperty,
  properties: state.search.properties,
  svnMember: state.ui.svnMember,
});

const mapDispatchToProps = {
  downloadPropertiesAsCsv,
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesPageHeader);
